import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var PublicLayout = function (props) {
    return (_jsx(_Fragment, { children: props.children }));
};
